import { Component, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { SERVICE_END_POINT } from 'src/app/shared/services/api-constants/service-endpoints.constants';
import { UtilService } from 'src/app/shared';



@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss'],
    encapsulation: ViewEncapsulation.None,
    imports: []
})
export class FooterComponent {

  public CMSData;
  public footerBlock;

  constructor(private activatedRoute: ActivatedRoute, private utilService: UtilService) {
    this.GetCMSDataServiceMapper();
  }

   /** Code block for CMS */
   GetCMSDataServiceMapper() {
    const URL = SERVICE_END_POINT.higherEnvironment.CMS_HeaderAndFooter;
    this.utilService.getCMSData(URL).subscribe(res => {
      this.CMSData = res;
      if (this.CMSData) {
      /** In the line below we are over-writing the contentData object values with CMSData object values */
      this.footerBlock = this.CMSData.html_Footer;
  
    }
    });
  }
  /** End of code block for CMS */

  displayText(text) {
      return text.replace('cookie policy', 'Cookie policy');
  }

}
